import { isEmpty } from '../../../common/functions';

export const toDecimal = (value: string) => {
  return isEmpty(value) ? undefined : parseFloat(value) / 100;
};
